/*! jQuery Validation Plugin - v1.21.0 - 7/17/2024
 * https://jqueryvalidation.org/
 * Copyright (c) 2024 Jörn Zaefferer; Licensed MIT */
!function (a) {
  "function" == typeof define && define.amd ? define(["jquery", "../jquery.validate.min"], a) : "object" == typeof module && module.exports ? module.exports = a(require("jquery")) : a(jQuery);
}(function (a) {
  return a.extend(a.validator.messages, {
    required: "ეს ველი სავალდებულოა.",
    remote: "გთხოვთ შეასწოროთ.",
    email: "გთხოვთ შეიყვანოთ სწორი ფორმატით.",
    url: "გთხოვთ შეიყვანოთ სწორი ფორმატით.",
    date: "გთხოვთ შეიყვანოთ სწორი თარიღი.",
    dateISO: "გთხოვთ შეიყვანოთ სწორი ფორმატით (ISO).",
    number: "გთხოვთ შეიყვანოთ რიცხვი.",
    digits: "დაშვებულია მხოლოდ ციფრები.",
    creditcard: "გთხოვთ შეიყვანოთ სწორი ფორმატის ბარათის კოდი.",
    equalTo: "გთხოვთ შეიყვანოთ იგივე მნიშვნელობა.",
    maxlength: a.validator.format("გთხოვთ შეიყვანოთ არა უმეტეს {0} სიმბოლოსი."),
    minlength: a.validator.format("შეიყვანეთ მინიმუმ {0} სიმბოლო."),
    rangelength: a.validator.format("გთხოვთ შეიყვანოთ {0} -დან {1} -მდე რაოდენობის სიმბოლოები."),
    range: a.validator.format("შეიყვანეთ {0} -სა {1} -ს შორის."),
    max: a.validator.format("გთხოვთ შეიყვანოთ მნიშვნელობა ნაკლები ან ტოლი {0} -ს."),
    min: a.validator.format("გთხოვთ შეიყვანოთ მნიშვნელობა მეტი ან ტოლი {0} -ს.")
  }), a;
});